<template>
	<div class="wrapper">
		<div class="use">
			<div class="content">
				<span class="logo">
					<img src="../assets/logo.png" alt="logo">
				</span>
				<div class="head">
					<header></header>
					<span class="title">中石油{{amount}}元电子油卡</span>
				</div>
				<div class="body">
					<p>有效期: {{effectiveDate}} - {{expiredDate}}</p>
					<h1 style="color: red;">DT加油</h1>
					<h1>兑换码: {{ticket.ticketNum}}</h1>
					<div class="code" @click="getTicket">
						<svg id="barcode"></svg>
						<div class="qrcode" ref="qrCodeUrl"></div>
					</div>
					<div class="balance" v-if="balance">油卡余额 {{balance}} 元</div>
					<div class="sec">每30秒自动刷新，点击二维码可手动刷新</div>
					<div class="sec">请出示以上券码给门店工作人员</div>
					<div class="dec">网点存在变动可能，使用前请先确认服务网点信息</div>
					<div class="btn">
						<router-link to='/oilStationList' class="button">查看服务网点</router-link>
					</div>
				</div>
				<div class="foot">
					<h1>券码规则</h1>
					<p>1.收银机消费路径是<span class="">DT加油</span>，如遇到收银机问题，请拨打电话 0571-85199986，电子券请在有效期内使用，逾期作废；</p>
					<p>2.本券为动态二维码，截图无效</p>
					<p>3.本券仅限在浙江省内中国石油加油站加油使用</p>
					<p>4.因卡券产品特殊，一经出售，不予退换，本卡券不提供发票</p>
					<p>5.本券只可用于购买油品即加油，不可用于便利店消费，也不能用于购买预付卡券、促销礼品或其他商品</p>
					<p>6.一个订单最多使用1张电子券，也可以支持加油券+现金支付；</p>
					<p>7.中石油电子券为一次性核销券，需要一次性使用完；</p>
					<p>8.请在买单前出示电子券信息，验证成功后即使用，离柜无效；</p>
					<p>9.该电子券不记名，不挂失，可转赠，但只能验证消费一次</p>
					<p>10.客服热线0571-85199986（08:30-20:30）如无人接听，请加18158107296微信客服留言。</p>
				</div>
			</div>
		</div>
		<div class="used" v-if="used">
			<div class="box">
				<p>￥{{amount}}</p>
				<span>中石油{{amount}}元电子油卡</span>
			</div>
			<div class="dec">
				<div class="lt">
					<p>有效期:</p>
					<p>{{effectiveDate}}- {{expiredDate}}</p>
				</div>
				<span>{{usedText}}</span>
			</div>
		</div>
		<div class="use_loading" v-if="loading">
			<div class="loading">
				<img src="../assets/loading.png" alt="加载中">
			</div>
		</div>
	</div>
</template>
<script>
	import QRCode from 'qrcodejs2'; //引入生成二维码插件
	import JsBarcode from 'jsbarcode';
	// var JsBarcode = require('jsbarcode');
	export default {
		data() {
			return {
				loading: true,
				key: this.$route.query.key,
				amount: this.$route.query.amount,
				effectiveDate: this.$route.query.effectiveDate,
				expiredDate: this.$route.query.expiredDate,
				status: this.$route.query.status,
				balance: this.$route.query.balance,
				ticket: {},
				used: false,
				usedText: '已使用',
				timeOut: undefined
			}
		},
		mounted() {
			this.getTicket();
			// this.creatQrCode(this.key);
			// JsBarcode("#barcode", this.key, {
			// 	displayValue: false,
			// 	width: 1.8,
			// 	height: 60,
			// });
			let self = this;
			this.timeOut = setTimeout(() => {
				self.getTicket()
			}, 25000);
		},
		methods: {
			creatQrCode(val) {
				this.$refs.qrCodeUrl.innerHTML = ''; //清除二维码方法一
				let qrcode = new QRCode(this.$refs.qrCodeUrl, {
					text: val,
					width: 178,
					height: 178,
					colorDark: '#000000',
					colorLight: '#ffffff',
					correctLevel: QRCode.CorrectLevel.H
				});
				this.loading = false;
			},
			getTicket() {
				const obj = {
					ticketNo: this.key,
					isVerify: '-1',
				};
				this.$http.POST('productTicket/selectProductTicket', obj).then(res => {
					this.loading = false;
					if (res.code === 0) {
						if (res.data.useStatus != 0) {
							this.used = true;
							if (res.data.useStatus == 4) {
								this.usedText = '已失效'
							} else {
								this.usedText = '已使用'
							}
							clearTimeout(this.timeOut);
						} else {
							this.used = false;
							this.ticket = res.data;
							this.creatQrCode(this.ticket.ticketNum);
							JsBarcode("#barcode", this.ticket.ticketNum, {
								displayValue: false,
								width: 1.8,
								height: 60,
							});
						}
					}
				});
			}
		}
	}
</script>
<style lang="scss" scoped>
	.wrapper {
		// height: 100%;
		position: relative;

		.use {
			// height: 100%;
			background: #108EE9;
			padding: 30px 15px 15px 15px;
			box-sizing: border-box;

			.content {
				background: #fff;
				border-radius: 4px;
				background: url('../assets/code_bg.png') #fff center 20px no-repeat;
				background-size: 305px 338px;
				min-height: 338px;
				position: relative;

				.logo {
					position: absolute;
					display: inline-block;
					right: 0;
					top: 0;

					img {
						width: 51px;
						height: 51px;
					}
				}

				.head {
					position: relative;
					height: 30px;
					width: 100%;
					display: flex;
					justify-content: center;

					header {
						width: 190px;
						border-top: 30px solid #2C78DC;
						border-right: 12px solid transparent;
						border-left: 12px solid transparent;
						box-sizing: border-box;
						height: 30px;
					}

					.title {
						font-size: 15px;
						position: absolute;
						top: 0;
						left: 0;
						color: #fff;
						width: 100%;
						height: 30px;
						line-height: 30px;
						text-align: center;
					}
				}

				.body {
					border-bottom: 1px dashed #CCCCCC;

					p {
						font-size: 15px;
						color: #999999;
						text-align: center;
						padding-top: 10px;
					}

					h1 {
						font-size: 20px;
						color: #333333;
						text-align: center;
						padding-top: 15px;
					}

					.code {
						padding-top: 10px;
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;

						.qrcode {
							padding-top: 10px;
						}
					}

					.balance {
						padding-top: 20px;
						text-align: center;
						font-size: 18px;
					}

					.sec {
						font-size: 15px;
						color: #999999;
						padding: 10px 0 15px 0;
						text-align: center;
					}

					.dec {
						font-size: 15px;
						background: #FEFCEC;
						padding: 10px 0;
						color: #F76A24;
						text-align: center;
					}

					.btn {
						display: flex;
						justify-content: center;
						padding: 15px 0 30px 0;

						.button {
							font-size: 15px;
							width: 200px;
							height: 40px;
							line-height: 40px;
							text-align: center;
							color: #fff;
							background: #1E87FC;
							border-radius: 4px;
						}
					}
				}

				.foot {
					padding: 24px 17px;

					h1 {
						font-size: 20px;
						color: #333333;
						font-weight: bold;
					}

					p {
						color: #666666;
						font-size: 15px;
						line-height: 28px;

						span {
							color: red;
							font-size: 20px;
						}
					}
				}
			}
		}

		.used {
			height: 100%;
			padding: 10px 15px;
			box-sizing: border-box;
			position: absolute;
			left: 0;
			top: 0;
			z-index: 9;
			width: 100%;
			background: #fff;

			.box {
				height: 85px;
				background: url('../assets/used_bg.png') no-repeat;
				background-size: 345px 85px;
				display: flex;
				flex-direction: column;

				p {
					color: #333333;
					font-size: 35px;
					font-weight: bold;
					padding: 10px 0 0 15px;
					flex: 1;
				}

				span {
					font-size: 15px;
					color: #555555;
					text-align: right;
					padding: 5px;
				}
			}

			.dec {
				// height: 60px;
				background: #fff;
				display: flex;
				align-items: center;
				padding: 0 10px;

				.lt {
					flex: 1;
					padding: 0 10px 10px 0;

					p {
						font-size: 15px;
						color: #999999;
						padding-top: 5px;
					}
				}

				span {
					width: 80px;
					height: 30px;
					text-align: center;
					line-height: 30px;
					color: #fff;
					background: linear-gradient(to right, #AFAFAF, #C4C4C4);
					font-size: 15px;
					border-radius: 15px;
				}
			}
		}

		.use_loading {
			position: absolute;
			height: 100%;
			width: 100%;
			z-index: 11;
			left: 0;
			top: 0;

			.loading {
				width: 100%;
				height: 100%;
				background: rgba(0, 0, 0, 0.5);
				display: flex;
				justify-content: center;
				align-items: center;

				img {
					width: 50px;
					height: 50px;
					animation: turn .8s linear infinite;
					margin: 100px auto;
				}

				@keyframes turn {
					0% {
						-webkit-transform: rotate(0deg);
					}

					25% {
						-webkit-transform: rotate(90deg);
					}

					50% {
						-webkit-transform: rotate(180deg);
					}

					75% {
						-webkit-transform: rotate(270deg);
					}

					100% {
						-webkit-transform: rotate(360deg);
					}
				}
			}
		}
	}
</style>
